import { SubmitGroupItemModel, SubmitItem } from '@libs/form/models';

export const CHIP_CONTROL_SUBMIT_RESET: string = 'reset';
export const CHIP_CONTROL_SUBMIT_CLOSE: string = 'close';

export const CHIP_CONTROL_SUBMIT_RESET_ITEM: SubmitItem = {
  name: CHIP_CONTROL_SUBMIT_RESET,
  label: 'Zurücksetzen',
  theme: 'text',
};

export const CHIP_CONTROL_SUBMIT_CLOSE_ITEM: SubmitItem = {
  name: CHIP_CONTROL_SUBMIT_CLOSE,
  label: 'Schließen',
  theme: 'outlined',
};

export const CHIP_CONTROL_SUBMIT_CONFIG: SubmitGroupItemModel = {
  type: 'submit',
  items: [
    CHIP_CONTROL_SUBMIT_RESET_ITEM,
    CHIP_CONTROL_SUBMIT_CLOSE_ITEM,
  ],
};
